import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { RequestNewCardValidationSchema } from "../schemas/requestNewCard.schema";

interface UseRequestNewCardProps {
  id?: string;
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useRequestNewCard = ({ id, onSuccess, onError }: UseRequestNewCardProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['requestNewCard', id],
    mutationFn: (form: RequestNewCardValidationSchema) => privateAxios.post(`/client/cards/${id}/request_new_card`, {
      request_observation: form.request_observation,
      request_reason_id: form.request_reason?.value,
    }),
    onSuccess,
    onError,
  });
};
